'use strict';

export default {
  silentJSONParsing: true,
  forcedJSONParsing: true,
  clarifyTimeoutError: false
};



//////////////////
// WEBPACK FOOTER
// E:/项目/渠道推广统计/statisticsLizu/node_modules/axios/lib/defaults/transitional.js
// module id = null
// module chunks = 